import * as React from 'react'

// Components
import Svg from './..'

const Check = props => {
  return (
    <Svg fill='none' height='1em' viewBox='0 0 14 12' width='1em' {...props}>
      <path
        clipRule='evenodd'
        d='M12.688.556L14 1.868l-9.188 9.188L0 6.243l1.313-1.312 3.5 3.5z'
        fill='#3ce967'
        fillRule='evenodd'
      />
    </Svg>
  )
}

export default Check
